module.exports = __webpack_public_path__ + "img/plan_001.3d1f8559.jpg";